import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import { datadogRum } from '@datadog/browser-rum';
import api from '@services/api';
import type { ResumedUserType } from '@customTypes/user';

const useGetAllUsersList = () => {
  const [users, setUsers] = useState<ResumedUserType[]>([]);
  const [loading, setLoading] = useState(true);

  const getAllUsers = useCallback(async () => {
    setLoading(true);
    try {
      const response = await api.get('/user/all');
      setUsers(response.data);
    } catch (error) {
      toast.error('Erro ao carregar usuários. Tente novamente mais tarde.');
      datadogRum.addError(new Error('Fail to get full users list'), { error });
    } finally {
      setLoading(false);
    }
  }, []);

  return { getAllUsers, users, loading };
};

export default useGetAllUsersList;
